import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-137">
      <div className="max-w-4xl mx-auto" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-forest text-white p-8 md:p-12 rounded-3xl relative overflow-hidden shadow-2xl" data-id="element-139">
          <Quote className="absolute top-6 left-6 w-24 h-24 text-white/10 -z-0" data-id="element-140" />

          <div className="relative z-10 text-center space-y-6" data-id="element-141">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-orange-light" data-id="element-142">
              ¿Qué cambia en 24 horas?
            </h2>

            <p className="text-lg md:text-xl leading-relaxed font-medium" data-id="element-143">
              Al eliminar los irritantes y facilitar el vaciado gástrico, la
              circunferencia de tu cintura puede reducirse entre{' '}
              <span className="text-orange font-bold bg-white/10 px-2 py-1 rounded" data-id="element-144">
                2 y 4 centímetros
              </span>{' '}
              simplemente por la liberación de presión gaseosa y líquido
              retenido.
            </p>

            <div className="inline-block border-t border-white/20 pt-6 mt-4" data-id="element-145">
              <p className="text-xl font-serif italic text-forest-100" data-id="element-146">
                "No es magia, es descompresión biológica."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}